import { render } from "./Populartoday.vue?vue&type=template&id=64f2d910&scoped=true&ts=true"
import script from "./Populartoday.vue?vue&type=script&setup=true&lang=ts"
export * from "./Populartoday.vue?vue&type=script&setup=true&lang=ts"

import "./Populartoday.vue?vue&type=style&index=0&id=64f2d910&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64f2d910"],['__file',"src/components/home/Populartoday.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64f2d910"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64f2d910', __exports__)) {
    console.log('reload')
    api.reload('64f2d910', __exports__)
  }
  
  module.hot.accept("./Populartoday.vue?vue&type=template&id=64f2d910&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('64f2d910', render)
  })

}


export default __exports__